<script lang="ts">
    // import iconAdd from '../../../assets/delete_FILL0_wght400_GRAD0_opsz24.svg';
    export let hover: string = '';
    export let src: string = '';
    export let alt: string = '';
    export let scale: number = 1;
    export let style: string = '';
    export let spin: boolean = false;
    export let backgroundColor: string = '#f92672';

    if (style==='') {
        style = `transform: scale(${scale});`;
    } else {
        style = `${style} transform: scale(${scale});`;
    }

</script>


<div on:click class:spin title={hover} style="width:{30*scale}px; height:{30*scale}px;background-color:{backgroundColor}" class="icon" >
    <img {src} {alt} style="width:{25*scale}px; height:{25*scale}px; {style}" />
</div>


<style lang="scss">
  .icon {
    border-radius: 50%;
  }
  .icon:hover {
    cursor: pointer;
  }
  @keyframes spin-animate {
      from {
          transform: rotate(0deg);
      }
      to {
          transform: rotate(360deg);
      }
  }

  .spin {
      // filter: blur(1px) brightness(0.8) saturate(0.8) contrast(1.2);
      filter: scale(0.8);
      animation: spin-animate 0.3s linear infinite;
  }

</style>